import styled from 'styled-components'

export const ModalAlert = styled.div`
  .modal-alert {
    margin-top: 15px;
    font-size: 19px;
    text-align: center;
    color: ${({ theme }) => theme.cor41}!important;
  }
  font-family: Roboto;

  .mantine-Group-root {
    justify-content: center !important;
  }
`

export const TituloCriarSMS = styled.h1`
  font-weight: 600;
  font-size: 20px;
  color: ${({ theme }) => theme.cor9} !important;
  margin-bottom: 16px;
`

export const MensagemCriarSMS = styled.p`
  font-weight: 500;
  font-size: 18px;
  color: ${({ theme }) => theme.cor66} !important;
`

export const MessagemAtencaoWrapper = styled.div`
  .mensagem-corpo {
    width: 500px !important;
  }
`
